import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";
import { VirtualTourPlugin } from "@photo-sphere-viewer/virtual-tour-plugin";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import { GalleryPlugin } from "@photo-sphere-viewer/gallery-plugin";
import "@photo-sphere-viewer/markers-plugin/index.css";
import "@photo-sphere-viewer/virtual-tour-plugin/index.css";
import "@photo-sphere-viewer/gallery-plugin/index.css";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Tour() {

	const {id} = useLocation().state || {};
  
  const pSRef = React.createRef();
  const [getCurrentNodeFunction, setGetCurrentNodeFunction] =
    React.useState(null);
  const handleReady = (instance) => {
    const virtualTour = instance.getPlugin(VirtualTourPlugin);
    if (!virtualTour) return;

    const markerLighthouse = {
      id: "marker-1",
      // image: baseUrl + "pictos/pin-red.png",
      image: 'assets/pin-96.png',
      tooltip: "Cape Florida Light, Key Biscayne",
      size: { width: 32, height: 32 },
      anchor: "bottom center",
      gps: [-80.155973, 25.666601, 29 + 3],
    };
    
		console.log("start at node: " + id);

    virtualTour.setNodes([
      {
        id: 'F1LR',
        panorama: 'assets/compressed/living-room-360.jpeg',
        thumbnail: 'assets/living-room-1024x1024.png',
        name: 'Living Room',
        // caption: `[1] ${caption}`,
        caption: `Floor 1 - Living Room and Dining Room`,
        links: [
            { nodeId: 'F1R1', gps: [-120, 20.666623] },
            { nodeId: 'F1B', gps: [140, 20.666623] }, 
            { nodeId: 'F1K', gps: [-75, 20.666623] }, 
            { nodeId: 'F2LR', gps: [45, 20.666623] }
        ],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F1R1', // -> nodeId
        panorama: 'assets/compressed/KamarTidurLT1-360.jpeg',
        thumbnail: 'assets/room-1-1024x1024.png', // thumbnail for gallery
        name: 'Bedroom',
        caption: 'Floor 1 - Bedroom', 
        links: [
            { nodeId: 'F1LR' }
        ], // connect to other panorama
        gps: [-90.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F2R1', // -> nodeId
        panorama: 'assets/compressed/KamarTidurLT2-360.jpeg',
        thumbnail: 'assets/room-1-1024x1024.png', // thumbnail for gallery
        name: 'Bedroom',
        caption: 'Floor 2 - Bedroom', 
        links: [
            { nodeId: 'F2LR' }
        ], // connect to other panorama
        // markers: [markerLighthouse], // markers from marker plugin
        gps: [-90.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F2R2',
        panorama: 'assets/compressed/KamarUtamaLT2-360.jpeg',
        thumbnail: 'assets/room-2-1024x1024.png',
        name: 'Master Bedroom',
        caption: `Floor 2 - Master Bedroom`,
        links: [{ nodeId: 'F2LR' }],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F1K',
        panorama: 'assets/compressed/kitchen-360.jpeg',
        thumbnail: 'assets/kitchen-1024x1024.png',
        name: 'Kitchen',
        caption: `Floor 1 - Kitchen`,
        links: [{ nodeId: 'F1LR' }],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F2LR',
        panorama: 'assets/compressed/F2LR.jpeg',
        thumbnail: 'assets/floor-2-1024x1024.png',
        name: 'Floor 2',
        caption: `Floor 2`,
        links: [
          { nodeId: 'F1LR', gps: [100, 18] },
          { nodeId: 'F2WR',  gps: [0, 18] },
          { nodeId: 'F2R1',  gps: [-100, 18] },
          { nodeId: 'F2L', gps: [-85, 18] },
          { nodeId: 'F2B', gps: [-80, 18] },
          { nodeId: 'F2R2', gps: [-65, 18] }
        ],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F2WR',
        panorama: 'assets/compressed/F2WR.jpeg',
        thumbnail: 'assets/workroom-1024x1024.png',
        name: 'Working Room',
        caption: `Floor 2 - Working Room`,
        links: [
          { nodeId: 'F2LR', gps: [-85, 18] },
        ],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F1B',
        panorama: 'assets/compressed/KamarMandiLT1-360.jpeg',
        thumbnail: 'assets/F1B-1024x1024.png',
        name: 'Bathroom',
        caption: `Floor 1 - Bathroom`,
        links: [{ nodeId: 'F1LR' }],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },    
      {
        id: 'F2B',
        panorama: 'assets/compressed/KamarMandiAtas-360.jpeg',
        thumbnail: 'assets/F2B-1024x1024.png',
        name: 'Bathroom',
        caption: `Floor 2 - Bathroom`,
        links: [{ nodeId: 'F2LR' }],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      },
      {
        id: 'F2L',
        panorama: 'assets/compressed/LaundryRoom-360.jpeg',
        thumbnail: 'assets/F2L-1024x1024.png',
        name: 'Laundry Room',
        caption: `Floor 2 - Laundry Room`,
        links: [{ nodeId: 'F2LR' }],
        gps: [-80.155932, 25.666498, 5],
        sphereCorrection: { pan: '0deg' },
      }
  
    ], id); // set starting node here cuz virtualTour.setNodes([...], "2");


    const getCurrentNode = virtualTour.getCurrentNode.bind(virtualTour);
    setGetCurrentNodeFunction(() => getCurrentNode);
  };

  const handleClick = () => {
    console.log(getCurrentNodeFunction());
  };

  const plugins = [
    MarkersPlugin,
    [
      GalleryPlugin,
      {
        thumbnailSize: { width: 100, height: 100 },
      },
    ],
    [
      VirtualTourPlugin,
      {
        positionMode: "gps",
        renderMode: "3d",
      },
    ],
  ];


  return (
    <div className="App" id={"container-360"}>
      <ReactPhotoSphereViewer
        ref={pSRef}
        loadingImg= {"assets/loading.gif"}
        touchmoveTwoFingers={true}
        mousewheelCtrlKey={true}
        defaultYaw={"130deg"}
        navbar={[
          "zoom",
          "move",
          "gallery",
          "download",
          "description",
          "caption",
          "fullscreen",
        ]}
        height={"100vh"}
        width={"100%"}
        hideNavbarButton={true}
        onReady={handleReady}
        plugins={plugins}
        container={"container-360"}
        src={"assets/compressed/living-room-360.jpeg"}
      ></ReactPhotoSphereViewer>
      {/* <button onClick={handleClick}>Get Current Node</button> */}
    </div>
  );
}

export default Tour;
